<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter1onedynastytransformedintoafemaleemperor">CHAPTER 1 - ONE DYNASTY TRANSFORMED INTO A FEMALE EMPEROR</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter2stumbleagainsttheking">CHAPTER 2 - STUMBLE AGAINST THE KING</a>
</li>
<li class="table-of-content">
<span href="#/2_chapter3theelderlingsarecurioustointerrogatethevassals" title="Link target outside of Sample">CHAPTER 3 - THE ELDERLINGS ARE CURIOUS TO INTERROGATE THE VASSALS</span>
</li>
<li class="table-of-content">
<span href="#/3_chapter4herosadbeautypass" title="Link target outside of Sample">CHAPTER 4 - HERO SAD BEAUTY PASS</span>
</li>
<li class="table-of-content">
<span href="#/4_chapter5fifteencupsofspringwater" title="Link target outside of Sample">CHAPTER 5 - FIFTEEN CUPS OF SPRING WATER</span>
</li>
<li class="table-of-content">
<span href="#/5_chapter6thequeenoftravelingwiththearmy" title="Link target outside of Sample">CHAPTER 6 - THE QUEEN OF TRAVELING WITH THE ARMY</span>
</li>
<li class="table-of-content">
<span href="#/6_chapter7sandwolfshowingmysteriouslife" title="Link target outside of Sample">CHAPTER 7 - SAND WOLF SHOWING MYSTERIOUS LIFE</span>
</li>
<li class="table-of-content">
<span href="#/7_chapter8siriusinthehighmorage" title="Link target outside of Sample">CHAPTER 8 - SIRIUS IN THE HIGH MO RAGE</span>
</li>
<li class="table-of-content">
<span href="#/8_chapter9howmanygenerationsofpreviouslovedebthavebeenrepaid" title="Link target outside of Sample">CHAPTER 9 - HOW MANY GENERATIONS OF PREVIOUS LOVE DEBT HAVE BEEN REPAID</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter10soloveissobroken" title="Link target outside of Sample">CHAPTER 10 - SO LOVE IS SO BROKEN</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter11sowhatifhediedlikethis" title="Link target outside of Sample">CHAPTER 11 - SO WHAT IF HE DIED LIKE THIS</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter12thepastisalongstory" title="Link target outside of Sample">CHAPTER 12 - THE PAST IS A LONG STORY</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter13thepurpleskyisstillcomingoutbutitsstillbreakingdown" title="Link target outside of Sample">CHAPTER 13 - THE PURPLE SKY IS STILL COMING OUT BUT IT'S STILL BREAKING DOWN</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter14istartwithtwothings" title="Link target outside of Sample">CHAPTER 14 - I START WITH TWO THINGS</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter15meetingthekingofhellinnanluotown" title="Link target outside of Sample">CHAPTER 15 - MEETING THE KING OF HELL IN NANLUO TOWN</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter16threemenforaplay" title="Link target outside of Sample">CHAPTER 16 - THREE MEN FOR A PLAY</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter17mutationineverythingregretsintestinalregrets" title="Link target outside of Sample">CHAPTER 17 - MUTATION IN EVERYTHING REGRETS INTESTINAL REGRETS</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter18astormisbrewing" title="Link target outside of Sample">CHAPTER 18 - A STORM IS BREWING</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2b2d8341